import ArchiveFilter from './components/ArchiveFilter/ArchiveFilter';
import SwiperRelatedContent from './components/SwiperRelatedContent';
import SwiperNearContent from './components/SwiperNearContent';
import SwiperSingle from './components/SwiperSingle';
import { slideUp, slideDown, slideToggle } from './libs/slide';
import Swiper from 'swiper/bundle';

// スクロールバーの幅をCSSに格納する関数
const updateScrollBarWidth = () => {
  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`)
}
const debounce = (callback) => {
  let timeout;
  return (...args) => {
    if (timeout !== undefined) cancelAnimationFrame(timeout);
    timeout = requestAnimationFrame(() => callback(...args));
  };
};
window.addEventListener('resize', debounce(updateScrollBarWidth));
window.addEventListener('load', updateScrollBarWidth);

// ArchiveFilter
//
// アーカイブ一覧ページにおける絞り込みフォーム要素パーツ
if (document.querySelector('[data-role="archive-filter"]')) {
  if (document.querySelector('.archive-filter-area-map')) {
    // eslint-disable-next-line no-new
    new ArchiveFilter();
  } else {
    // eslint-disable-next-line no-new
    new ArchiveFilter({ disableAreaMapMode: true });
  }
}

//
// header関連
//

// クラスの切り替えと属性の更新を行う共通関数
function toggleElementState(element, className, expandedLabel, collapsedLabel, targetElement = null, animationDuration = 0) {
  const isOpen = element.classList.contains(className);
  
  element.classList.toggle(className);
  element.setAttribute('aria-expanded', !isOpen);
  element.setAttribute('aria-label', isOpen ? collapsedLabel : expandedLabel);

  if (targetElement && animationDuration > 0) {
    isOpen ? slideUp(targetElement, animationDuration) : slideDown(targetElement, animationDuration);
  }
}

// ハンバーガメニュー
const menuToggleBtn = document.querySelector('.js-menu-toggle');
if (menuToggleBtn) {
  menuToggleBtn.addEventListener('click', function () {
    toggleElementState(this, 'is-menu-open', '閉じる', 'メニュー');
    document.body.classList.toggle('is-hidden');
  });
  document.querySelectorAll('.js-section-toggle').forEach((btn) => {
    btn.addEventListener('click', function () {
      this.classList.toggle('is-open');
    });
  });
}

// (SP)検索ボタン
const searchToggleBtn = document.querySelector('[data-role="search-contents-show-btn"]');
if (searchToggleBtn) {
  searchToggleBtn.addEventListener('click', function () {
    toggleElementState(this, 'is-search-open', '閉じる', '検索ボックス', this.nextElementSibling, 300);
  });
}

// 言語選択ボタン
document.querySelectorAll('[data-role="language-select"]').forEach((languageSelecter) => {
  const languageSelectBtn = languageSelecter.querySelector('[data-role="language-select-btn"]');
  if (languageSelectBtn) {
    languageSelectBtn.addEventListener('click', function () {
      toggleElementState(this, 'is-menu-open', '閉じる', '言語選択メニュー', this.nextElementSibling, 300);
    });
  }
});

// よりよい観光に向けて
document.querySelectorAll('[data-role="citizen-select"]').forEach((citizenSelecter) => {
  const citizenSelectBtn = citizenSelecter.querySelector('[data-role="citizen-select-btn"]');
  if (citizenSelectBtn) {
    citizenSelectBtn.addEventListener('click', function () {
      toggleElementState(this, 'is-menu-open', '閉じる', 'よりよい観光に向けて選択メニュー', this.nextElementSibling, 300);
    });
  }
});

//
// tab
//
const cmnTabElms = document.querySelectorAll('[data-role="cmn-tab"]');
if (cmnTabElms.length) {
  cmnTabElms.forEach((elm) => {
    const tabBtnsArea = elm.querySelector('[role="tablist"]');
    tabBtnsArea.addEventListener('click', (ev) => {
      const tabBtnElm = ev.target;
      if (tabBtnElm.hasAttribute('data-target')) {
        let tabTarget;
        let tabCurrentTarget = tabBtnElm.getAttribute('data-target');

        // ボタン切り替え
        const tabBtns = elm.querySelectorAll('[data-role="tabbtn"]');
        tabBtns.forEach((tabBtn) => {
          tabTarget = tabBtn.getAttribute('data-target');
          if (tabTarget === tabCurrentTarget) {
            tabBtn.classList.add('is-active');
            tabBtn.ariaSelected = true;
            tabBtn.removeAttribute('tabindex');
          } else {
            tabBtn.classList.remove('is-active');
            tabBtn.ariaSelected = false;
            tabBtn.setAttribute('tabindex', '-1');
          }
        });

        // パネル切り替え
        const tabContentsElm = elm.querySelectorAll('[role="tabpanel"]');
        tabContentsElm.forEach((tabContents) => {
          tabTarget = tabContents.getAttribute('id');
          if (tabTarget === tabCurrentTarget) {
            tabContents.classList.add('is-active');
          } else {
            tabContents.classList.remove('is-active');
          }
        });
      }
    });
  });
}

//
// swiper
//

// 詳細ページMV
if (document.querySelector('[data-role="article-contents-mv-swiper"]') !== null) {
  // eslint-disable-next-line no-new
  let articleContentsMvSwiper = new Swiper('[data-role="article-contents-mv-swiper"]', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    centerInsufficientSlides: true,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1024: {
        slidesPerView: 1.2,
        spaceBetween: 24,
      },
    },
    speed: 1500,
    pagination: {
      el: "[data-role='article-contents-mv-swiper-pagination']",
      clickable: true,
    },
    navigation: {
      nextEl: '[data-role="article-contents-mv-swiper-next"]',
      prevEl: '[data-role="article-contents-mv-swiper-prev"]',
    },
  });
}

// 1枚画像
const singleSwiperElms = document.querySelectorAll("[data-role='single-swiper']");
if (singleSwiperElms.length) {
  singleSwiperElms.forEach((elm) => {
    // eslint-disable-next-line no-new
    new SwiperSingle({ elm });
  });
}

// 関連情報
const relatedContentSwiperElms = document.querySelectorAll("[data-role='related-content-swiper']");
if (relatedContentSwiperElms.length) {
  relatedContentSwiperElms.forEach((elm) => {
    // eslint-disable-next-line no-new
    new SwiperRelatedContent({ elm });
  });
}

// 近くのスポット
const nearContentSwiperElms = document.querySelectorAll("[data-role='near-contents-swiper']");
if (nearContentSwiperElms.length) {
  nearContentSwiperElms.forEach((elm) => {
    // eslint-disable-next-line no-new
    new SwiperNearContent({ elm });
  });
}

//
// 規約同意ボタンをチェックするとフォームが現れる
//
const agreeCheckbox = document.querySelector('.agreement-checkbox');
if (agreeCheckbox !== null) {
  const formElm = document.querySelector('[data-role="form-field"]');
  agreeCheckbox.addEventListener('click', () => {
    if (agreeCheckbox.checked === true) {
      slideDown(formElm, 300);
    } else {
      slideUp(formElm, 300);
    }
  });
}

//
// 右クリック禁止
//
const noRightClickImages = document.querySelectorAll('[data-role="no-right-click"] img');
noRightClickImages.forEach(img => {
  img.addEventListener('contextmenu', (event) => {
    event.preventDefault();
  });
});

//
// `祇` のみフォント変更
//
document.addEventListener("DOMContentLoaded", function () {
  function wrapTextWithSpan(element, targetText) {
      // テキストノード
      if (element.nodeType === Node.TEXT_NODE) {
          const regex = new RegExp(targetText, "g");
          if (element.textContent.match(regex)) {
              const newHTML = element.textContent.replace(regex, `<span class="ff-sans-serif">${targetText}</span>`);
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = newHTML;

              while (tempDiv.firstChild) {
                  element.parentNode.insertBefore(tempDiv.firstChild, element);
              }
              element.parentNode.removeChild(element);
          }
      }
      // 要素ノード
      else if (element.nodeType === Node.ELEMENT_NODE) {
          // 除外対象タグ
          const tagName = element.tagName.toUpperCase();
          const isJsonLdScript = tagName === "SCRIPT" && element.type === "application/ld+json";
          const isStyleOrScript = tagName === "STYLE" || tagName === "SCRIPT";

          if (!isJsonLdScript && !isStyleOrScript) {
              Array.from(element.childNodes).forEach(child => wrapTextWithSpan(child, targetText));
          }
      }
  }

  wrapTextWithSpan(document.body, "祇");
});
